const config = {
    'BASE_URL': 'https://api-prod.wannalisn.com',
    'ASTEX_BASE_URL': 'https://api-provider.wannalisn.cloud.astex.es',
    'READ_SERVER_URL': 'https://read-prod.wannalisn.com/v1/graphql',
    'ASTEX_READ_SERVER_URL': 'https://read-prod.wannalisn.cloud.astex.es/v1/graphql',
    'VIDEOS_BASE_URL': 'https://du9ufcmxxlip6.cloudfront.net/clips/',
}

export default config
